<h1 mat-dialog-title>Paramètres de connexion au réseau eHealth</h1>
<mat-dialog-content>
	<div *ngIf="ehealth.certificateAvailable">
		<h2>Un certificat est déjà présent dans ce navigateur</h2>
		<button style="margin-top: 10px;" class="field-full-width" mat-button (click)="cleanCertificate()">Nouveau certificat</button>
	</div>
	<div *ngIf="!ehealth.certificateAvailable">
		<h2>Certificat eHealth</h2>
		<div class="uploader">
			<angular-file-uploader #certUpload
				  [config]="afuConfig"
				  (ApiResponse)="certificateUpload($event)">
			</angular-file-uploader>
		</div>
		<mat-form-field class="field-full-width">
			<mat-label>Mot de passe du certificat</mat-label>
			<input matInput type="password" [(ngModel)]="certificatepass">
		</mat-form-field>
		<mat-slide-toggle [(ngModel)]="alternatecertificate">Ancien certificat (décodage d'anciens messages)</mat-slide-toggle>
		<div *ngIf="alternatecertificate">
			<div class="uploader">
				<angular-file-uploader #certAltUpload
							[config]="afuConfig"
							(ApiResponse)="certificateAltUpload($event)">
				</angular-file-uploader>
			</div>
			<mat-form-field class="field-full-width">
				<mat-label>Mot de passe de l'ancien certificat</mat-label>
				<input matInput type="password" [(ngModel)]="certificatealtpass">
			</mat-form-field>	
		</div>
		<div>
			<mat-slide-toggle [(ngModel)]="ehealth.isBrowserTrusted">Navigateur approuvé</mat-slide-toggle>
		</div>
	</div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Fermer</button>
  <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
  <button *ngIf="!ehealth.certificateAvailable" mat-button (click)="saveData()">Sauvegarder</button>
</mat-dialog-actions>